import { proxy, subscribe } from "valtio"
import { derive } from "valtio/utils"

// function init() {
//   let flag = localStorage.getItem("mySheet")
//   if (!flag) {
//     localStorage.setItem(
//       "mySheet",
//       JSON.stringify({
//         sheetList: []
//       })
//     )
//   }
// }
// init()

const sheetSetup = proxy(
  JSON.parse(localStorage.getItem("mySheet"))
    ? JSON.parse(localStorage.getItem("mySheet"))
    : {
        sheetList: []
      }
)
// 添加歌单
const addSheet = (val) => {
  let index = sheetSetup.sheetList.findIndex((item) => item.name == val)
  if (index > -1) {
    return false // 歌单已存在
  } else {
    sheetSetup.sheetList.push({ name: val, src: "", list: [] })
    return true // 添加成功
  }
}
// 移除歌单
const removeSheet = (val) => {
  let index = sheetSetup.sheetList.findIndex((item) => item.name == val)
  sheetSetup.sheetList.splice(index, 1)
}
// 歌单编辑
const editSheet = (val1, val2) => {
  let index = sheetSetup.sheetList.findIndex((item) => item.name == val1)
  sheetSetup.sheetList[index].name = val2.name
  sheetSetup.sheetList[index].src = val2.src
}
// 添加歌曲到歌单
const addSheetSong = (val1, val2) => {}
// 删除歌单歌曲
const removeSheetSong = (val1, val2) => {
  let index = sheetSetup.sheetList.findIndex((item) => item.name == val1)
  let idx = sheetSetup.sheetList[index].list.findIndex(
    (item) => item.id == val2
  )
  sheetSetup.sheetList[index].list.splice(idx, 1)
}
// 类似于计算属性
const derived = derive({
  sheetList: () => sheetSetup.sheetList
})

subscribe(sheetSetup, () => {
  localStorage.setItem("mySheet", JSON.stringify(sheetSetup))
})
export {
  addSheet,
  removeSheet,
  editSheet,
  addSheetSong,
  removeSheetSong,
  derived
}

export default sheetSetup
